export default {
  status: {
    rejected: {
      title: "Bestellung storniert",
    },
    created: {
      title: "Bestellung erhalten",
    },
    reviewed: {
      title: "Deine Bestellung wurde gesehen",
    },
    confirmed: {
      title: "Bestellung bestätigt",
    },
    waiting_confirmation: {
      title: "Warten auf Bestellbestätigung",
      description: "Einen Moment...",
    },
    pickup_time: {
      title: "Abholzeit",
      description: "Bestätigt von {{name}}",
    },
    delivery_time: {
      title: "Lieferzeit",
      description: "Bestätigt von {{name}}",
    },
  },
};
